import { useMemo } from "react";
import * as echarts from "echarts";
import { alpha, useTheme } from "@mui/material";
import ReactEChart from "../../../base/ReactEChart";

const CustomerFulfillmentChart = ({ chartRef, data, ...rest }) => {
  const theme = useTheme();

  const option = useMemo(
    () => ({
      color: [theme.palette.secondary.main, theme.palette.primary.main],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "line",
        },
      },
      legend: {
        show: false,
        data: ["This Month", "Last Month"],
      },
      grid: {
        top: 0,
        right: 5,
        bottom: 1,
        left: 5,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        show: true,
        data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        axisLabel: {
          show: false,
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: alpha(theme.palette.common.white, 0.06),
            width: 1,
          },
        },
      },
      yAxis: [
        {
          type: "value",
          show: false,
        },
      ],
      series: [
        {
          id: 1,
          name: "This Month",
          type: "line",
          stack: "Total",
          lineStyle: {
            width: 2,
          },
          showSymbol: true,
          symbol: "circle",
          symbolSize: 5,
          areaStyle: {
            opacity: 0.8,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 0.9, [
              {
                offset: 1,
                color: theme.palette.grey.A100,
              },
              {
                offset: 0,
                color: theme.palette.secondary.main,
              },
            ]),
          },
          emphasis: {
            focus: "series",
          },
          data: data["This Month"],
        },
        {
          id: 2,
          name: "Last Month",
          type: "line",
          stack: "Total",
          lineStyle: {
            width: 2,
          },
          showSymbol: true,
          symbol: "circle",
          symbolSize: 5,
          areaStyle: {
            opacity: 0.75,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 0.95, [
              {
                offset: 1,
                color: theme.palette.grey.A100,
              },
              {
                offset: 0,
                color: theme.palette.primary.main,
              },
            ]),
          },
          emphasis: {
            focus: "series",
          },
          data: data["Last Month"],
        },
      ],
    }),
    [theme, data]
  );

  return (
    <ReactEChart ref={chartRef} option={option} echarts={echarts} {...rest} />
  );
};

export default CustomerFulfillmentChart;
